import { createContext, useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import useGetAllKnowledgeDocumentSummaries from "../hooks/useKnowledgeBaseService";

const KnowledgeBaseOverviewContext = createContext();

export const KnowledgeBaseOverviewProvider = ({ children }) => {
  const pageSize = 6;

  const [allSummaries, setAllSummaries] = useState([]);

  const [pageNumber, setPageNumber] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(0);

  // Start with loading as true
  const [loading, setLoading] = useState(true);
  const { fetchedKnowledgeDocuments } = useGetAllKnowledgeDocumentSummaries();

  useEffect(() => {
    if (fetchedKnowledgeDocuments.knowledgeDocumentSummaries !== undefined) {
      setAllSummaries(fetchedKnowledgeDocuments.knowledgeDocumentSummaries);
      setLoading(false);
    }
  }, [fetchedKnowledgeDocuments]);

  useEffect(() => {
    setPageNumber(1);
    setNumberOfPages(Math.ceil(allSummaries.length / pageSize));
  }, [allSummaries]);

  return (
    <KnowledgeBaseOverviewContext.Provider
      value={{ allSummaries, pageNumber, numberOfPages, loading }}
    >
      {children}
    </KnowledgeBaseOverviewContext.Provider>
  );
};

export const useKnowledgeBaseOverview = () => useContext(KnowledgeBaseOverviewContext);

KnowledgeBaseOverviewProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
